import get from 'lodash/get';
import { types } from './actionTypes';

export const startFetchingAiIinsights = () => {
  return {
    type: types.SET_AI_INSIGHTS_LOADING,
    payload: {
      loading: true
    }
  };
};
export const successFetchDiscoverySegment = payload => {
  return {
    type: types.SET_DISCOVERY,
    payload
  };
};

export const fetchDiscoverySegment = payload => dispatch => {
  const { filters, benchmark } = payload;

  dispatch(startFetchingAiIinsights());
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      body: {
        filters: filters,
        benchmark
      },
      queryParams: {
        page_type: 'delightiq',
        campaign: 'discovery'
      }
    },
    onSuccess: ({ data }) => {
      const widgetList = get(data, 'data.widget_list[0].contents.contents');
      dispatch(successFetchDiscoverySegment(widgetList));
      dispatch({ type: types.SET_AI_INSIGHTS_LOADING, payload: { loading: false } });
    },
    onError: ({ error }) => {
      dispatch({ type: types.SET_AI_INSIGHTS_LOADING, payload: { loading: false } });
    }
  });
};
